import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  z-index: ${({ isOpen }) => (isOpen ? 9999 : -1)};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
`;

export const ModalContent = styled.div`
  height: 95vh;
  width: 95vw;

  video {
    max-width: 100%;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;

  i {
    color: #fff;
    font-size: 24px;
    opacity: 0.7;
    transition: all 0.2s;

    &:hover {
      opacity: 1;
    }
  }
`;
